// Homepage FAQ custom logic

  (function() {
    const faqBlock = document.querySelector('#onpulse-faq-block');
    if (!faqBlock) return;

    const items = faqBlock.querySelectorAll('.onpulse-faq-item');

    items.forEach(function(item) {
      const button = item.querySelector('.onpulse-faq-question');
      const icon = item.querySelector('.onpulse-faq-icon');

      if (!button) return;

      button.addEventListener('click', function() {
        const isOpen = item.classList.contains('is-open');

        items.forEach(function(otherItem) {
          otherItem.classList.remove('is-open');
          const otherIcon = otherItem.querySelector('.onpulse-faq-icon');
          if (otherIcon) otherIcon.textContent = '+';
        });

        if (!isOpen) {
          item.classList.add('is-open');
          if (icon) icon.textContent = '+';
        }
      });
    });
  })();
